
import { toast } from "sonner";
import { logger } from "@/utils/logger";

// List of errors that should be silently logged but not shown to users
const SILENT_ERROR_PATTERNS = [
  "Edge Function",
  "context",
  "Failed to send a request",
  "Failed to fetch",
  "JWT expired",
  "Invalid JWT",
  "Auth session missing",
  "Auth token is missing",
  "token is missing",
  "Socket protocol error",
  "_a.isStatic is not a function", // React Query compatibility issue
];

/**
 * Check if an error should be silently logged without showing a toast
 */
function isSilentError(message: string): boolean {
  if (!message) return false;
  return SILENT_ERROR_PATTERNS.some(pattern => 
    message.toLowerCase().includes(pattern.toLowerCase())
  );
}

export function logErrorToast(message: string, error?: unknown) {
  // Always log error details using production logger
  if (error) {
    logger.error("Error details", { message, error });
  } else {
    logger.error("Error", { message });
  }
  
  // Only show toast if it's not a silent error
  if (!isSilentError(message)) {
    toast.error(message);
  } else {
    // For silent errors, only log
    logger.warn("Suppressed error toast (auth or network issue likely)", { message });
  }
}

export function logInfoToast(message: string) {
  logger.info("Info toast", { message });
  toast.info(message);
}

export function logSuccessToast(message: string) {
  logger.info("Success toast", { message });
  toast.success(message);
}
